<template>
  <div>
    <div v-if="eyebrowText" v-style:c="eyebrowTextColor" class="uppercase">
      {{ eyebrowText }}
    </div>
    <cms-base-responsive-media
      v-if="eyebrowLogoResponsive"
      class-name="h-full"
      fit="contain"
      :media="eyebrowLogoResponsive"
      :position
      :props-img="{ class: 'max-h-24 object-left' }"
    />
  </div>
</template>

<script setup lang="ts">
import type { Responsive } from '#types/common'
import type { StyledEyebrow } from '#types/styles'

type EyebrowProps = StyledEyebrow & {
  /**
   * Specifies responsive object-position values for the internal <img>
   */
  position?: Responsive<string> | string
}

defineProps<EyebrowProps>()
</script>
